import { z } from 'zod';

/**
 * Workflow status for a region document:
 *
 * - `active`        — reviewed by the Super Admin (us). Trustworthy for routing and customer display.
 * - `needs_review`  — auto-created by the runtime Google Maps flow (`createRegionDynamically`).
 *                     Boundaries are from Google's viewport — usable but should be reviewed.
 * - `unverified`    — imported from a low-precision source (e.g. an Excel row where the boundary
 *                     came from `osm_locality` or a synthetic placeholder box around the center).
 */
export const regionStatusSchema = z.enum(['active', 'needs_review', 'unverified']);

export type RegionStatus = z.infer<typeof regionStatusSchema>;
